import { j as e } from "./jsx-runtime-DywqP_6a.js";
import { useEffect as i } from "react";
import { e as u, b as m } from "./chunk-PVWAREVJ-BO6B-RAk.js";
import { S as x, B as r, L as h } from "./index-CVfG8Pb4.js";
import { C as a, a as c, b as o, c as d, d as l } from "./Card-hTy9PAnh.js";
import { d as n } from "./ZudokuContext-BcqSiygJ.js";
const C = () => {
  const t = n(), [s] = u();
  return i(() => {
    t.authentication?.signIn({
      redirectTo: s.get("redirect") ?? void 0,
      replace: !0
    });
  }, [t.authentication, s]), /* @__PURE__ */ e.jsx("div", { className: "flex items-center justify-center mt-8", children: /* @__PURE__ */ e.jsxs(a, { className: "max-w-md w-full", children: [
    /* @__PURE__ */ e.jsxs(c, { children: [
      /* @__PURE__ */ e.jsx(o, { className: "text-lg", children: "Sign in" }),
      /* @__PURE__ */ e.jsx(d, { children: "You're being redirected to our secure login provider to complete your sign-in process." })
    ] }),
    /* @__PURE__ */ e.jsx(l, { children: /* @__PURE__ */ e.jsxs("div", { className: "flex items-center text-sm font-medium gap-2", children: [
      /* @__PURE__ */ e.jsx(x, {}),
      " Redirecting..."
    ] }) })
  ] }) });
}, S = () => {
  const t = n(), s = m();
  return i(() => {
    t.authentication?.signOut().then(() => s("/"));
  }, [t.authentication, s]), null;
}, b = () => {
  const t = n();
  return i(() => {
    t.authentication?.signUp() ?? t.authentication?.signIn();
  }, [t.authentication]), /* @__PURE__ */ e.jsx("div", { className: "flex items-center justify-center mt-8", children: /* @__PURE__ */ e.jsxs(a, { className: "max-w-md w-full", children: [
    /* @__PURE__ */ e.jsxs(c, { children: [
      /* @__PURE__ */ e.jsx(o, { className: "text-lg", children: "Sign up" }),
      /* @__PURE__ */ e.jsx(d, { children: "You're being redirected to our secure login provider to complete your sign up process." })
    ] }),
    /* @__PURE__ */ e.jsx(l, { children: /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-2 justify-center", children: [
      /* @__PURE__ */ e.jsx(
        r,
        {
          onClick: () => t.authentication?.signIn(),
          variant: "default",
          children: "Register"
        }
      ),
      /* @__PURE__ */ e.jsx(r, { variant: "link", className: "text-muted-foreground", asChild: !0, children: /* @__PURE__ */ e.jsx(h, { to: "/", children: "Go home" }) })
    ] }) })
  ] }) });
};
export {
  S,
  C as a,
  b
};
//# sourceMappingURL=SignUp-C-YP_Rxi.js.map
